// extracted by mini-css-extract-plugin
export default {"form-wrapper":"ModalSetVideo_form-wrapper__JsIzX","input-wrapper":"ModalSetVideo_input-wrapper__a05rP","select-wrapper":"ModalSetVideo_select-wrapper__HLBgY"};